import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"

import CardView from "./components/CardView"
import { Collection } from "../../models"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    refreshItems: (itemIds: number[]) => void
    reload: () => void
    removeItem: (itemId: number) => void
    start: (
        element: HTMLElement | undefined | null,
        collection: Collection,
    ) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const refreshItems = (itemIds: number[]): void => {
        store.dispatch(actions.refreshItems(itemIds))
    }

    const reload = (): void => {
        store.dispatch(actions.reload())
    }

    const removeItem = (itemId: number): void => {
        store.dispatch(actions.removeItem(itemId))
    }

    const start = (
        element: HTMLElement | undefined | null,
        collection: Collection,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(actions.initialize(collection))

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <OldUIContext.Consumer>
                        {(): JSX.Element => <CardView />}
                    </OldUIContext.Consumer>
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    return {
        refreshItems,
        reload,
        removeItem,
        start,
    }
}

export default init
